import { useParams } from 'react-router-dom';
import PolicyTable from './PolicyTable';

const DevicePolicySection = () => {
  const { deviceId } = useParams();

  return <PolicyTable deviceId={deviceId} />;
};

export default DevicePolicySection;
